import type { NskResponse } from "~/models/Api";
import type {
	CsvRequestParams,
	Encoding,
	Type
} from "~/models/CsvGenerationResult";
import { postRequest } from "~/utils/api/api_handler";
import type { DealSearchCondition } from "../../../models/Deal";

const createPath = "/vendors/csv_generation_results";
export const requestCsvGenerate = (
	parameters: DealSearchCondition,
	csvType: Type,
	encoding: Encoding,
	endpoint = createPath
): Promise<NskResponse<CsvRequestParams>> =>
	postRequest<CsvRequestParams, null>(endpoint, {
		csv_generation_result: {
			csv_type: csvType,
			encoding,
			parameters
		}
	});

export const getPresignedUrl = async (id: number): Promise<string | null> => {
	const url = `${process.env.NEXT_PUBLIC_API_HOST}/api/vendors/csv_generation_results/${id}/download`;
	try {
		const res = await fetch(url, { credentials: "include" });
		if (!res.ok) {
			return null;
		}
		const data: { presigned_url: string } = await res.json();
		return data.presigned_url;
	} catch {
		return null;
	}
};
